import { render, staticRenderFns } from "./SwitchInput.vue?vue&type=template&id=4556f506&"
import script from "./SwitchInput.vue?vue&type=script&lang=js&"
export * from "./SwitchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports